import { render, staticRenderFns } from "./CreateStateModal.vue?vue&type=template&id=4f96caba&scoped=true&"
import script from "./create-state-modal.ts?vue&type=script&lang=ts&"
export * from "./create-state-modal.ts?vue&type=script&lang=ts&"
import style0 from "./create-state-modal.scss?vue&type=style&index=0&id=4f96caba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f96caba",
  null
  
)

export default component.exports